import IMeasurement from 'interfaces/products/IMeasurement';
import IProductId from 'interfaces/products/IProductId';

// The code of a type of a product, e.g. the code of Inlook 365
const codeOf = (type: string) => (cell: IProductId[] | undefined) =>
  cell?.find((productId) => productId.type === type)?.value;

/**
 * The columns of the product list: the codes of Inlook 365, the old one of Inlook and the
 * supplier's, the name, the measurements and the day the product was added. The keys are
 * the searches of the columns.
 */
const getProductColumns = (
  t: any,
  dateLocale: string
): { dataField: string; formatter: any; searchKey: string; text: string }[] => [
  {
    dataField: 'productIds',
    formatter: codeOf('inlook'),
    searchKey: 'inlookId',
    text: t('listColumns.inlook'),
  },
  {
    dataField: 'productIds',
    formatter: codeOf('inlook-old'),
    searchKey: 'inlookOldId',
    text: t('listColumns.inlookOld'),
  },
  {
    dataField: 'productIds',
    formatter: codeOf('supplier'),
    searchKey: 'supplierId',
    text: t('listColumns.supplier'),
  },
  {
    dataField: 'name',
    formatter: (name: string | undefined) => name,
    searchKey: 'name',
    text: t('listColumns.name'),
  },
  {
    // E.g. "koko M10" or "korkeus 2400 mm, leveys 1200 mm"; the size given as text first
    dataField: 'measurements',
    formatter: (
      measurements: IMeasurement[] | undefined,
      row: { size?: null | string }
    ) =>
      [
        row.size ? `${t('attributeTypes.size')} ${row.size}` : '',
        ...(measurements ?? []).map((measurement) =>
          [
            t(`measurementTypes.${measurement.type}`),
            String(measurement.value).replace('.', ','),
            measurement.siUnit,
          ]
            .filter(Boolean)
            .join(' ')
        ),
      ]
        .filter(Boolean)
        .join(', '),
    searchKey: 'measurement',
    text: t('listColumns.measurement'),
  },
  {
    dataField: 'created',
    formatter: (created: string | undefined) =>
      created ? new Date(created).toLocaleDateString(dateLocale) : '',
    searchKey: 'created',
    text: t('listColumns.created'),
  },
];

export default getProductColumns;
